

import { Component, SimpleChanges, OnInit, OnChanges, ViewChild, ElementRef, ViewContainerRef, ComponentFactoryResolver, ComponentRef, Input, Output, EventEmitter } from '@angular/core';
// import { MatInput, MatSelectChange } from '@angular/material';

@Component({
    selector: 'eform-field',
    templateUrl: './field.html',
    styleUrls: ['./field.scss']
  })
export class EFormField implements OnInit, OnChanges {

    @Input('ctl')
    ctl: any;

    @Output('change')
    onChange: EventEmitter<{name: string, value: any}> = new EventEmitter<{name: string, value: any}>();

    // @ViewChild('section', {static: true, read: ViewContainerRef})
    // section: ViewContainerRef;

    // constructor(private componentFactoryResolver: ComponentFactoryResolver) {}
    constructor(private ref: ElementRef) {}

    ngOnInit() {
        // console.log(this.ctl);
        this.load();
    }

    ngOnChanges(changes : SimpleChanges) {
        this.load();
    }

    load() {
        if (!this.ctl) return;

        if (!this.ctl.hidden) {
            if (this.ctl.visible == null || this.ctl.visible == undefined) {
                this.ctl.visible = 1;
            }
        }
        
        if (!this.ctl.disabled) {
            if (this.ctl.enabled == null || this.ctl.enabled == undefined) {
                this.ctl.enabled = 1;
            }
        }

        if (!this.ctl.readonly) {
            if (this.ctl.editable == null || this.ctl.editable == undefined) {
                this.ctl.editable = 1;
            }
        }

        if (this.ctl.size) {
            this.setSize(this.ctl.size);
        }
        // this.section.clear();

        //     for(let control of this.layout.controls) {
        //         this.createControl(control, this.section);
        //     }
    }

    // createControl(ctl: any, parent: ViewContainerRef) {
    //     const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MatInput);
    
    //     const componentRef = parent.createComponent(componentFactory);
    //     componentRef.instance.type = ctl.datatype || 'text';
    //     componentRef.instance.placeholder = ctl.label || ctl.name;
    //     componentRef.instance.readonly = ctl.readonly || null;
    //     componentRef.instance.disabled = ctl.disabled || !ctl.enabled;
    //     componentRef.instance.required = ctl.required || !ctl.optional;

    //     (<MatInput>componentRef.instance).value = null;
    // }

    setSize(size: number) {
        let el = this.ref.nativeElement;        //section.element.nativeElement.parent;
        el.style.flexGrow = size;
        el.style.minWidth = (size * 3) + 'rem';
        el.style.maxWidth = (size * 9) + 'rem';
    }
    
    changeValue() {
        let change = {name: this.ctl.name, value: this.ctl.value};
        this.onChange.emit(change);
    }

    selectItem(event: any) {
        // this.ctl.selected = event.value;
        // this.ctl.value = (event.value)? event.value.value : null;
        this.ctl.value = (this.ctl.selected)? this.ctl.selected.value : null;
        let change = {name: this.ctl.name, value: this.ctl.selected};
        // alert(JSON.stringify(change));
        this.onChange.emit(change);
    }
}